import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { SpinnerService } from '../../_components/spinner/spinner.service';
import { MessageService } from 'primeng/api';
import { Constants } from '../Constants';
import { TranslateService } from '@ngx-translate/core';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const spinner = inject(SpinnerService);
  const message = inject(MessageService);
  const translate = inject(TranslateService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      spinner.hide();

      if (err.error?.message === 'Token expired') {
        return throwError(() => err);
      }

      const errorCode = err.error?.code || err.error?.error?.code;
      const errorMessage = err.error?.message || err.error?.error?.message;
      const errorParams = err.error?.params || err.error?.error?.params;

      if (errorCode) {
        message.add({
          severity: 'error',
          summary: translate.instant('errors.error_title'),
          detail: translate.instant(
            Constants.ErrorMessages.getTranslationKey(errorCode),
            errorParams
          ),
          life: Constants.Notifications.LIFE,
          key: Constants.Notifications.ERROR_KEY,
        });
      } else {
        message.add({
          severity: 'error',
          summary: translate.instant('errors.error_title'),
          detail: errorMessage,
          life: Constants.Notifications.LIFE,
          key: Constants.Notifications.ERROR_KEY,
        });
      }

      return throwError(() => err);
    })
  );
};
